import { memoizePromiseStorage } from '../ipfsCache';
import { initGetPublicIPFSData } from './getPublicIPFSData';

const getPublicIPFSData = initGetPublicIPFSData();

export async function getIpfsImage(cid: string): Promise<Blob> {
  // eslint-disable-next-line no-return-await
  return memoizePromiseStorage<Blob>(cid, () => {
    return getPublicIPFSData<Blob>(cid, { parseAs: 'blob' });
  });
}
